import React from 'react';
import './index.css';

import { ThemeProvider } from './context/ThemeContext';
import { CVProvider } from './context/CVContext';
import { useCVParam } from './hooks/useCVParam';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import { useAttentionTitle } from './hooks/useAttentionTitle';
import { useTracking } from './hooks/useTracking';
import { useSectionTracking } from './hooks/useSectionTracking';
import { useClientErrorReporter } from './hooks/useClientErrorReporter';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Skills from './components/sections/Skills';
import Projects from './components/sections/Projects';
import Experience from './components/sections/Experience';
import Contact from './components/sections/Contact';
import PortfolioChat from './components/sections/PortfolioChat';
import './index.css'; // Ensure global styles are imported

function MainAppLayout() {
  // Inizializza Google Analytics e traccia navigazione
  useGoogleAnalytics();
  // Traccia visite su MySQL
  useTracking();
  // Traccia sezioni visitate nel portfolio SPA
  useSectionTracking();
  // Attiva il cambio dinamico del titolo per attirare l'attenzione
  useAttentionTitle();
  // Invia al server gli errori JS non gestiti
  useClientErrorReporter();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
      </main>
      <Footer />
      <PortfolioChat />
    </div>
  );
}

function App() {
  const { isCVMode, phone } = useCVParam();

  return (
    <ThemeProvider>
      <CVProvider isCVMode={isCVMode} phone={phone}>
        <MainAppLayout />
      </CVProvider>
    </ThemeProvider>
  );
}

export default App;
